import React from 'react';
import {bool, number} from 'prop-types';

import AreaIndicator from '../common/AreaIndicator.jsx';

const QuotaDisplay = ({quota, isUnlimited}) => {
  if (isUnlimited) {
    return 'Unlimited';
  }

  return <AreaIndicator squareMeters={quota} />;
};

QuotaDisplay.propTypes = {
  quota: number,
  isUnlimited: bool,
};

export default QuotaDisplay;
